module.exports = __webpack_public_path__ + "fonts/la-regular-400.338f6f8.woff";